import signalIcon from "@tabler/icons/outline/signal.svg";
import React from "react";

import { Icon } from "../../../components/ui";

interface SignalProps {
  size?: number;
}

const Signal = (props: SignalProps) => {
  const { size = 5 } = props;

  return (
    <div className="relative">
      <Icon
        src={signalIcon}
        className={`size-${size + 1} z-2 text-secondary`}
      />
      <div className="absolute top-1/2 left-1/2 z-1 -mt-2.5 -ml-2.5 size-5">
        <Icon
          src={signalIcon}
          className={`size-${size} animate-ping text-secondary/70`}
        />
      </div>
    </div>
  );
};

export default Signal;
